import { RouterModule, Routes } from '@angular/router';

import { QuestionComponent } from './pages';

const routes: Routes = [
  { path: '', component: QuestionComponent }
];

export const routing = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts